import request from './request'

export function post(url, data) {
  return request({
    url: url,
    method: 'post',
    data: data
  })
}

export function get(url, data) {
  return request({
    url: data ? url + '/' + data : url,
    method: 'get'
  })
}
